import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup, CustomInput,
    Label, Input, InputGroup, InputGroupAddon, Button
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardPublicacionesRealizadas from "components/Varios/CardPublicacionesRealizadas.js";

import FileUpload from "components/Varios/FileUpload.js";
import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';
import { mensajeCamposIncompletos } from './constants';

const id = 1043;
const API_URL = configData.SERVER_URL

export const MensajeEncabezadoContactoDecanatoInvestigacion = <p>Estimado profesor, la información de esta sección es tomada de la plataforma de Gestión
de Proyectos de Investigación, <a href="https://gestionproyectos.espol.edu.ec" target="_blank">gestionproyectos.espol.edu.ec</a>. En caso de presentar problemas
con la información subida en esta plataforma en relación a proyectos de investigación y
publicaciones científicas, favor contactarse con la persona que administra la plataforma de Gestión de investigación en el Decanato 
de Investigación (dec_investigacion@espol.edu.ec).</p>


export class PublicacionesRealizadasData {
    idpublicacionpersona: number = 0;
    idpersona: number = 0;

    anio: string = "";
    tipoparticipacion: number = 0;
    estadopublicacion: number = 0;
    baseindexacion: number = 0;

    institucion: string = "";
    nombrerevista: string = "";
    titulo: string = "";
    urlpublicacion: string = "";
    nroISBN: string = "";
    tipopublicacion: string = "";
    factorimpacto: string = "";
    revisionpares: string = "";
    revistaindexada: string = "";

    tabla: string = "";
    refarchivo1: string = "";
    refarchivo2: string = "";
    refarchivo3: string = "";
}


interface PublicacionesRealizadasDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: PublicacionesRealizadasData;
    PublicacionesRealizadasDataList: PublicacionesRealizadasData[];
    tiposList: Array<any>;
    tiposParticipacionList: Array<any>;
    estadosList: Array<any>;
    tiposIndexacionList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
}

export class PublicacionesRealizadas extends React.Component<RouteComponentProps<{}>, PublicacionesRealizadasDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new PublicacionesRealizadasData(),
            PublicacionesRealizadasDataList: [], tiposList: [], tiposParticipacionList: [], estadosList: [], tiposIndexacionList: [], error: null, tiposEvidencia: [],
            filesData: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarPublicacionesRealizadas = this.cargarPublicacionesRealizadas.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    //this.cargarDatos();
                    this.cargarPublicacionesRealizadas();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        //API PARA OBTENER TIPOS
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/TIPO PUBLICACION")
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            tiposList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        tiposList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER TIPO PARTICIPACION PUBLICACION
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/TIPO PARTICIPACION PUBLICACION")
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            tiposParticipacionList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        tiposParticipacionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER TIPO ESTADO PUBLICACION
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/ESTADO PUBLICACION")
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            estadosList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        estadosList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER TIPO INDEXACION LIBRO
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/TIPO INDEXACION LIBRO")
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            tiposIndexacionList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        tiposIndexacionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    //API PARA OBTENER INFORMACIÓN ACADÉMICA DE PERSONA
    cargarPublicacionesRealizadas() {
        fetch(API_URL + "DatosEscalafon/PublicacionesDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            PublicacionesRealizadasDataList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(null)
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener la información académica.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        PublicacionesRealizadasDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        this.setState({
            dtoData: dto,
        });
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
        });

    }

    cargarEvidencias(tipoEvidencia) {
        var tiposEvidencia = [{ "value": "EAC", "label": "Certificado de mención de honor" }];
        //console.log("cargarEvidencias: tiposEvidencia=" + tiposEvidencia.map(te => te.value + " => " + te.label).join(", "));
        return tiposEvidencia;
    }

    descargarEvidencias(infoAcademica: PublicacionesRealizadasData) {
        var evidencias = new Array();
        if (infoAcademica.refarchivo1) {
            evidencias.push({ name: "PU" + this.state.currentUser.identificacion + "-" + infoAcademica.tabla + "1.PDF", url: API_URL + "DatosEscalafon/RefarchivoPublicacion/" + infoAcademica.tabla + "/1/" + infoAcademica.idpublicacionpersona + "/" + infoAcademica.idpersona });
        }
        if (infoAcademica.refarchivo2) {
            evidencias.push({ name: "PU" + this.state.currentUser.identificacion + "-" + infoAcademica.tabla + "2.PDF", url: API_URL + "DatosEscalafon/RefarchivoPublicacion/" + infoAcademica.tabla + "/2/" + infoAcademica.idpublicacionpersona + "/" + infoAcademica.idpersona });
        }
        if (infoAcademica.refarchivo3) {
            evidencias.push({ name: "PU" + this.state.currentUser.identificacion + "-" + infoAcademica.tabla + "3.PDF", url: API_URL + "DatosEscalafon/RefarchivoPublicacion/" + infoAcademica.tabla + "/3/" + infoAcademica.idpublicacionpersona + "/" + infoAcademica.idpersona });
        }
        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new PublicacionesRealizadasData() });
    }

    onClickEdit(tabla, idpublicacionpersona) {
        this.setState({
            dtoData: new PublicacionesRealizadasData()
        });

        fetch(API_URL + "DatosEscalafon/PublicacionesByTablaId/" + tabla + "/" + idpublicacionpersona + "/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(null),
                            loading: false
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);

                    } else {
                        alertService.error(result["strMensaje"])
                    }

                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        dtoData: new PublicacionesRealizadasData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idpublicacionpersona) {
        fetch(API_URL + "FormularioController/DeleteDatosMencionHonor/" + idpublicacionpersona, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("La información académica se eliminó correctamente.")
                        this.cargarPublicacionesRealizadas();
                    }
                })
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;

            if (clave === 'fecha') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }

        });

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (formIsValid) {
            if (dto.idpublicacionpersona === 0) {
                fetch(API_URL + "FormularioController/PostDatosMencionHonor", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(mensajeCamposIncompletos())
                            }
                            else if (responseJson["strEstado"] === "S") {

                                alertService.success("La mención de honor se ha registrado correctamente.")

                                //if (filesData.length > 0) {
                                //    var formFilesData = new FormData();

                                //    filesData.map((fileData) => {
                                //        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                //    });

                                //    formFilesData.append('idpublicacionpersona', responseJson.teducacionformal.idpublicacionpersona);

                                //    fetch(API_URL + "FormularioController/PostFilesDatosPublicacionesRealizadas", {
                                //        method: 'POST',
                                //        body: formFilesData
                                //    })
                                //        .then(response => response.json())
                                //        .then(success => {
                                //            // Do something with the successful response
                                //        })
                                //        .catch(error => //console.log(error));
                                //}
                                this.cargarPublicacionesRealizadas();
                                this.onClickLimpiar();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }

                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosMencionHonor", {

                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])

                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La mención de honor se ha actualizado correctamente.")
                                //if (filesData.length > 0) {
                                //    var formFilesData = new FormData();

                                //    filesData.map((fileData) => {
                                //        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                //    });

                                //    formFilesData.append('idpublicacionpersona', responseJson.teducacionformal.idpublicacionpersona);

                                //    fetch(API_URL + "FormularioController/PostFilesDatosPublicacionesRealizadas", {
                                //        method: 'POST',
                                //        body: formFilesData
                                //    })
                                //        .then(response => response.json())
                                //        .then(success => {
                                //            // Do something with the successful response
                                //        })
                                //        .catch(error => //console.log(error));
                                //}
                                this.onClickLimpiar();
                                this.cargarPublicacionesRealizadas();

                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }

                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        }
                    )
            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }

    }

    public render() {

        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.PublicacionesRealizadasDataList, this.state.tiposList, this.state.tiposParticipacionList,
                this.state.estadosList, this.state.tiposIndexacionList, this.state.tiposEvidencia);
        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(PublicacionesRealizadasDataList: Array<any>, tiposList: Array<any>, tiposParticipacionList: Array<any>,
        estadosList: Array<any>, tiposIndexacionList: Array<any>, tiposEvidencia: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">PUBLICACIONES REALIZADAS</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    { MensajeEncabezadoContactoDecanatoInvestigacion }
                                    {
                                        //<form onSubmit={this.handleSave}>
                                        //    <Row form>
                                        //        <Col md={6}>
                                        //            <FormGroup>
                                        //                <Label for="titulo">Título de publicación</Label>
                                        //                <Input type="text" name="titulo" id="titulo" value={this.state.dtoData.titulo} onChange={this.handleChange} required readOnly />
                                        //            </FormGroup>
                                        //        </Col>
                                        //        <Col md={4}>
                                        //            <FormGroup>
                                        //                <Label for="tipopublicacion">Tipo de publicación</Label>
                                        //                <SelectItem
                                        //                    options={tiposList}
                                        //                    value={this.state.dtoData.tipopublicacion}
                                        //                    onChange={this.handleSelectChange}
                                        //                    placeholder=""
                                        //                    name="tipopublicacion"
                                        //                    id="tipopublicacion"
                                        //                    icon="fa-caret-right"
                                        //                    disabled={true}
                                        //                />
                                        //            </FormGroup>
                                        //        </Col>
                                        //        <Col md={2}>
                                        //            <Label for="anio">Año de publicación</Label>
                                        //            <Datepicker
                                        //                value={this.state.dtoData.anio}
                                        //                name="anio"
                                        //                id="anio"
                                        //                onChange={this.handleSelectChange}
                                        //                dateFormat="yyyy"
                                        //                disabled={true}
                                        //            />
                                        //        </Col>
                                        //        {(
                                        //            ['A', 'S', 'C'].includes(this.state.dtoData.tipopublicacion) ?
                                        //                <Col md={6}>
                                        //                    <FormGroup>
                                        //                        {(['A', 'C'].includes(this.state.dtoData.tipopublicacion) ? <Label for="nombrerevista">Nombre de revista</Label> : <Label for="nombrerevista">Nombre de evento</Label>)}
                                        //                        <Input type="text" name="nombrerevista" id="nombrerevista" value={this.state.dtoData.nombrerevista} onChange={this.handleChange} required readOnly />
                                        //                    </FormGroup>
                                        //                </Col>
                                        //                :
                                        //                null
                                        //        )}
                                        //        <Col md={3}>
                                        //            <FormGroup>
                                        //                <Label for="tipoparticipacion">Tipo de participación</Label>
                                        //                <SelectItem
                                        //                    options={tiposParticipacionList}
                                        //                    value={this.state.dtoData.tipoparticipacion}
                                        //                    onChange={this.handleSelectChange}
                                        //                    placeholder=""
                                        //                    name="tipoparticipacion"
                                        //                    id="tipoparticipacion"
                                        //                    icon="fa-caret-right"
                                        //                    disabled={true}
                                        //                />
                                        //            </FormGroup>
                                        //        </Col>
                                        //        {(
                                        //            ['A', 'C'].includes(this.state.dtoData.tipopublicacion) ?
                                        //                <Col md={3}>
                                        //                    <FormGroup>
                                        //                        <Label for="tipoparticipacion">Estado de la publicación</Label>
                                        //                        <SelectItem
                                        //                            options={estadosList}
                                        //                            value={this.state.dtoData.estadopublicacion}
                                        //                            onChange={this.handleSelectChange}
                                        //                            placeholder=""
                                        //                            name="estadopublicacion"
                                        //                            id="estadopublicacion"
                                        //                            icon="fa-caret-right"
                                        //                            disabled={true}
                                        //                        />
                                        //                    </FormGroup>
                                        //                </Col>

                                        //                :
                                        //                null
                                        //        )}

                                        //        {(
                                        //            ['A', 'C'].includes(this.state.dtoData.tipopublicacion) ?
                                        //                <Col md={2}>
                                        //                    <FormGroup>
                                        //                        <Label for="revistaindexada">Revista indexada</Label>
                                        //                        <Row>
                                        //                            <Col md={5}>
                                        //                                <CustomInput
                                        //                                    className="col-md-5 ml-1"
                                        //                                    type="radio"
                                        //                                    checked={this.state.dtoData.revistaindexada === "S"}
                                        //                                    value="S"
                                        //                                    id="revistaindexada"
                                        //                                    name="revistaindexada"
                                        //                                    onChange={this.handleChange}
                                        //                                    label="Sí"
                                        //                                    disabled={true}
                                        //                                />
                                        //                            </Col>
                                        //                            <Col md={5}>
                                        //                                <CustomInput
                                        //                                    className="col-md-6"
                                        //                                    type="radio"
                                        //                                    value="N"
                                        //                                    id="revistaindexada2"
                                        //                                    name="revistaindexada"
                                        //                                    checked={this.state.dtoData.revistaindexada === "N"}
                                        //                                    onChange={this.handleChange}
                                        //                                    label="No"
                                        //                                    disabled={true}
                                        //                                />
                                        //                            </Col>
                                        //                        </Row>

                                        //                    </FormGroup>
                                        //                </Col>
                                        //                :
                                        //                null
                                        //        )}

                                        //        {(
                                        //            ['A', 'C'].includes(this.state.dtoData.tipopublicacion) ?
                                        //                <Col md={4}>
                                        //                    <FormGroup>
                                        //                        <Label for="baseindexacion">B.D Revistas Indexadas</Label>
                                        //                        <SelectItem
                                        //                            options={tiposIndexacionList}
                                        //                            value={this.state.dtoData.baseindexacion}
                                        //                            onChange={this.handleSelectChange}
                                        //                            placeholder=""
                                        //                            name="baseindexacion"
                                        //                            id="baseindexacion"
                                        //                            icon="fa-caret-right"
                                        //                            disabled={true}
                                        //                        />
                                        //                    </FormGroup>
                                        //                </Col>
                                        //                :
                                        //                null
                                        //        )}

                                        //        <Col md={3}>
                                        //            <FormGroup>
                                        //                {(['S'].includes(this.state.dtoData.tipopublicacion) ? <Label for="nroISBN">Código</Label> : <Label for="nroISBN">Código ISSN/ISBN</Label>)}
                                        //                <Input type="text" name="nroISBN" id="nroISBN" value={this.state.dtoData.nroISBN} onChange={this.handleChange} required readOnly />
                                        //            </FormGroup>
                                        //        </Col>

                                        //        {(
                                        //            ['A', 'C'].includes(this.state.dtoData.tipopublicacion) ?
                                        //                <Col md={3}>
                                        //                    <FormGroup>
                                        //                        <Label for="factorimpacto">Factor Impacto</Label>
                                        //                        <Input type="text" name="factorimpacto" id="factorimpacto" value={this.state.dtoData.factorimpacto} onChange={this.handleChange} required readOnly />
                                        //                    </FormGroup>
                                        //                </Col>
                                        //                :
                                        //                null
                                        //        )}
                                        //        {(
                                        //            ['S','L'].includes(this.state.dtoData.tipopublicacion) ?
                                        //                <Col md={3}>
                                        //                    <FormGroup>
                                        //                        {(['S'].includes(this.state.dtoData.tipopublicacion) ? <Label for="institucion">Lugar o centro</Label> : <Label for="institucion">Editor(a)</Label>)}
                                        //                        <Input type="text" name="institucion" id="institucion" value={this.state.dtoData.institucion} onChange={this.handleChange} required readOnly />
                                        //                    </FormGroup>
                                        //                </Col>
                                        //                :
                                        //                null
                                        //        )}
                                        //        {(
                                        //            ['L'].includes(this.state.dtoData.tipopublicacion) ?
                                        //                <Col md={3}>
                                        //                    <FormGroup>
                                        //                        <Label for="tipoidentificacion">Tuvo revisión por pares</Label>
                                        //                        <Row>
                                        //                            <Col md={5}>
                                        //                                <CustomInput
                                        //                                    className="col-md-5 ml-1"
                                        //                                    type="radio"
                                        //                                    checked={this.state.dtoData.revisionpares === "S"}
                                        //                                    value="S"
                                        //                                    id="revisionpares"
                                        //                                    name="revisionpares"
                                        //                                    onChange={this.handleChange}
                                        //                                    label="Sí"
                                        //                                    disabled={true}
                                        //                                />
                                        //                            </Col>
                                        //                            <Col md={5}>
                                        //                                <CustomInput
                                        //                                    className="col-md-6"
                                        //                                    type="radio"
                                        //                                    value="N"
                                        //                                    id="revisionpares2"
                                        //                                    name="revisionpares"
                                        //                                    checked={this.state.dtoData.revisionpares === "N"}
                                        //                                    onChange={this.handleChange}
                                        //                                    label="No"
                                        //                                    disabled={true}
                                        //                                />
                                        //                            </Col>
                                        //                        </Row>

                                        //                    </FormGroup>
                                        //                </Col>
                                        //                :
                                        //                null
                                        //        )}
                                        //        <Col md={6}>
                                        //            <FormGroup>
                                        //                <Label for="urlpublicacion">URL de publicación</Label>
                                        //                <Input type="text" name="urlpublicacion" id="urlpublicacion" value={this.state.dtoData.urlpublicacion} onChange={this.handleChange} required readOnly />
                                        //            </FormGroup>
                                        //        </Col>
                                        //        {
                                        //        //    <Col md={3}>
                                        //        //    <Label for="fechagraduacion">Evidencia</Label>
                                        //        //    <FormGroup row>
                                        //        //        <Col sm={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 9 : 12)}>
                                        //        //            <FileUpload id="evidencias" icon="upload" placeholder="Evidencias"
                                        //        //                options={tiposEvidencia} onChange={this.handleFileUploadChange} values={this.state.filesData} />
                                        //        //        </Col>
                                        //        //        <FileDownload files={this.descargarEvidencias(this.state.dtoData)} icon="download" />
                                        //        //    </FormGroup>
                                        //        //</Col>
                                        //        }

                                        //    </Row>

                                        //    {//<Row form>
                                        //    //    <Col md={12}>
                                        //    //        <FormGroup>
                                        //    //            <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                        //    //            <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                        //    //        </FormGroup>
                                        //    //    </Col>
                                        //    //</Row>
                                        //    }

                                        //</form >
                                    }

                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {PublicacionesRealizadasDataList.map((dto, index) =>
                                                <CardPublicacionesRealizadas
                                                    key={dto.idpublicacionpersona}
                                                    objeto={dto}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + PublicacionesRealizadasDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.tabla, dto.idpublicacionpersona)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default PublicacionesRealizadas;